import { xmlRpcEndpoint } from '@/services/Authentication';
import {xmlRpcClient} from './client';


// Create Business Hours Instance
const createBusinessHours = (instanceName: string, data: any) => {
  const verbCreate = 'instancename.createinstance';
  const paramsCreate = [
    {
      Type: 'TIME',
      Instancename: instanceName,
      Params: {
        GUI_MAILBOX_NR: '',
        GUI_ZEITRAEUME_DER_UMLEITUNG: data.GUI_ZEITRAEUME_DER_UMLEITUNG ? data.GUI_ZEITRAEUME_DER_UMLEITUNG : [],
        GUI_SPRACHE_VON_DATUMUHRZEIT: 'de',
        GUI_UMLEITUNG_VON: ['*'],
        GUI_KOMPATIBILITAETSMODUS: 'false',
        GUI_INTERNE_ANRUFE_IGNORIEREN: 'false',
        GUI_UMLEITUNGSZIEL: 'Ansage',
        GUI_AUSNAHMEN_2: [''],
        GUI_RUFNUMMER: '',
        GUI_UMLEITUNG_FUER: data.GUI_UMLEITUNG_FUER ? [data.GUI_UMLEITUNG_FUER] : [''],
        GUI_AUSNAHMEN: [],
        GUI_ANSAGE: data.GUI_ANSAGE ? data.GUI_ANSAGE : ''
      },
    },
  ];
  return client(verbCreate, paramsCreate);
};

// Update Business Hours Instance
const updateBusinessHours = (instanceName: string, data: any) => {
  const verbUpdate = 'instancename.modifyinstance';
  const paramsUpdate = [
    {
      Type: 'TIME',
      Instancename: instanceName,
      Params: {
        GUI_ZEITRAEUME_DER_UMLEITUNG: data.GUI_ZEITRAEUME_DER_UMLEITUNG ? data.GUI_ZEITRAEUME_DER_UMLEITUNG : [],
        GUI_UMLEITUNG_FUER: [data.GUI_UMLEITUNG_FUER],
        GUI_ANSAGE: data.GUI_ANSAGE ? data.GUI_ANSAGE : '',
      },
    },
  ];
  return client(verbUpdate, paramsUpdate);
};

// Delete Business Hours Instance
const deleteBusinessHours = (instanceName: string) => {
  const verbDelete = 'instancename.deleteinstance';
  const paramsDelete = [
    {
      Type: 'TIME',
      Instancename: instanceName,
    },
  ];
  return client(verbDelete, paramsDelete);
};

// Get Business Hours Instance
const getBusinessHours = async (instanceName: string) => {
  const verbGet = 'instancename.getinstance';
  const paramsGet = [
    {
      Type: 'TIME',
      Instancename: instanceName,
    },
  ];
  return client(verbGet, paramsGet);
};

// Enable Business Hours Instance
const toggleBusinessHours = async (instanceName: string, state: boolean) => {
  const verbGet = state ? 'instancename.enableinstance' : 'instancename.disableinstance';
  const paramsGet = [
    {
      Type: 'TIME',
      Instancename: instanceName,
    },
  ];
  return client(verbGet, paramsGet);
};

const client = async (verb: any, params: any) => {
    const retData = await xmlRpcClient(xmlRpcEndpoint(), verb, params);
    return retData;
  };


export { getBusinessHours, deleteBusinessHours, updateBusinessHours, createBusinessHours, toggleBusinessHours };
